// lodash
import find from 'lodash/find';
import has from 'lodash/has';

export default function mergeAddressBook(oldAddressBook, newAddressBook) {
  return newAddressBook.map((address) => {
    const { id } = address;
    const old = find(oldAddressBook, { id });

    if (old) {
      // add in any non-existent keys from the old address record
      return Object.keys(old).reduce((acc, key) => {
        if (!has(acc, key)) {
          return {
            ...acc,
            [key]: old[key],
          };
        }
        return acc;
      }, address);
    }

    return address;
  });
}
